/**
 * Use Thank You Pages Hook
 *
 * @package RedfoxThankYou
 * @since   1.0.0
 */

export { useThankYouPages } from './hook';
export type { PaginationInfo, UseThankYouPagesParams, UseThankYouPagesReturn } from './types';

